import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const parentApi = axios.create({ baseURL: API_BASE_URL });

parentApi.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("parentToken") || localStorage.getItem("parentToken");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

parentApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const hasToken = sessionStorage.getItem("parentToken") || localStorage.getItem("parentToken");
    if (error.response?.status === 401 && hasToken) {
      sessionStorage.removeItem("parentToken");
      sessionStorage.removeItem("parentInfo");
      localStorage.removeItem("parentToken");
      localStorage.removeItem("parentInfo");
      window.location.href = "/parent/login";
    }
    return Promise.reject(error);
  }
);

export default parentApi;
